import { render, staticRenderFns } from "./ProductConfigurationItem.vue?vue&type=template&id=f66753a8&scoped=true"
import script from "./ProductConfigurationItem.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationItem.vue?vue&type=style&index=0&id=f66753a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66753a8",
  null
  
)

export default component.exports